module.exports = __webpack_public_path__ + "img/mission-item-bg2.e6e9069d.png";